<template>
  <div id="PageGhgCalculator">
    <SectionWebinar />
    <SectionComplexity />
    <SectionCSRD />
  </div>
</template>

<script setup lang="ts">
import SectionCSRD from '@/views/components/sections/SectionCSRD.vue'
import SectionComplexity from '@/views/components/sections/SectionComplexity.vue'
import SectionWebinar from './sections/SectionWebinar.vue'
import { useSeo, getBreadcrumbStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// SEO Configuration
useSeo(
  getSeoConfig('webinar'),
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    { name: 'Webinar', url: 'https://sustainalyse.com/webinar' }
  ])
)
</script>

<style lang="scss" scoped>
#PageGhgCalculator {
  min-height: 100vh;
}
</style>
